import React from 'react';
import { IProps } from './type';

const WishlistIcon = ({ cName, width, height, fillColor, strokeColor, viewBox, onClick }: IProps) => {
  return (
    <svg
      className={cName}
      width={width ? width : '24'}
      height={height ? height : '24'}
      viewBox={viewBox ? viewBox : '0 0 24 24'}
      fill={fillColor ? fillColor : 'none'}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.23077 13.7016L11.3635 20.402C11.6412 20.6629 11.7801 20.7934 11.9471 20.8112C11.9823 20.8149 12.0177 20.8149 12.0529 20.8112C12.2199 20.7934 12.3588 20.6629 12.6365 20.402L17.5 15.8333L19.7692 13.7016C21.6322 11.9515 21.9529 9.10938 20.5266 6.98822C18.6426 4.18643 14.4917 4.27275 12.7259 7.15044L12.5209 7.48447C12.2824 7.87315 11.7176 7.87315 11.4791 7.48447L11.2741 7.15044C9.50828 4.27275 5.3574 4.18643 3.47344 6.98822C2.04714 9.10938 2.36776 11.9515 4.23077 13.7016Z"
        stroke={strokeColor || fillColor || "#212121"}
        strokeMiterlimit="16" />
    </svg>
  )
};

export default WishlistIcon;
